export enum InterfacePageName {
  AboutPage = 'about-page',
  Buy = 'buy-page',
  CreatePosition = 'create-position-page',
  ExplorePage = 'explore-page',
  ExtensionPasskeySignInPage = 'extension-passkey-sign-in-page',
  ExtensionUninstall = 'extension-uninstall',
  LandingPage = 'landing-page',
  Limit = 'limit-page',
  MigrateV2 = 'migrate-v2-page',
  MigrateV2Pair = 'migrate-v2-pair-page',
  MigrateV3 = 'migrate-v3-page',
  NftCollectionPage = 'nft-collection-page',
  NftDetailsPage = 'nft-details-page',
  NftExplorePage = 'nft-explore-page',
  NftProfilePage = 'nft-profile-page',
  NotFound = 'not-found',
  PoolDetailsPage = 'pool-details-page',
  PoolPage = 'pool-page',
  PortfolioOverviewPage = 'portfolio-overview-page',
  PortfolioTokensPage = 'portfolio-tokens-page',
  PortfolioDefiPage = 'portfolio-defi-page',
  PortfolioNftsPage = 'portfolio-nfts-page',
  PortfolioActivityPage = 'portfolio-activity-page',
  PortfolioPage = 'portfolio-page',
  PositionDetails = 'position-details-page',
  Positions = 'positions-page',
  Send = 'send-page',
  SwapPage = 'swap-page',
  TokenDetailsPage = 'token-details',
  TokensPage = 'tokens-page',
  VotePage = 'vote-page',
  // alphabetize additional values.
}
